/** Всё, что нужно тряске от элемента: его `style.transform`. */
export interface ShakeTarget {
  style: { transform: string };
}

/**
 * Применение тряски к цели (§113 п. 1). Прежний `transform` цели запоминается в
 * начале тряски и возвращается в её конце: чужой transform не затирается пустой
 * строкой. Цель берётся лениво — реф заполняется после монтирования.
 */
export function createShakeApplier(
  getTarget: () => ShakeTarget | null,
): (offset: { x: number; y: number } | null) => void {
  let shaken: { element: ShakeTarget; previous: string } | null = null;
  return (offset) => {
    if (offset === null) {
      if (shaken !== null) {
        shaken.element.style.transform = shaken.previous;
        shaken = null;
      }
      return;
    }
    if (shaken === null) {
      const element = getTarget();
      if (element === null) {
        return;
      }
      shaken = { element, previous: element.style.transform };
    }
    shaken.element.style.transform = `translate(${offset.x}px,${offset.y}px)`;
  };
}
